export const CAT_POI_ICON = 'https://caterpillar.scene7.com/is/content/Caterpillar/CM20230710-8878b-1472e?wid=38&hei=44&fmt=png-alpha';
